module.exports = __webpack_public_path__ + "img/login13.7a29261c.png";